<div class="billing-page">

  <app-billing-header>
    <div class="dropdown" (appClickOutside)="closeDropdownIfOpen('range')">
      <button type="button" class="range-picker" (click)="toggleDropdown('range', $event)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/>
        </svg>
        {{ rangeLabel() }}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      @if (openDropdown === 'range') {
        <div class="dropdown__menu">
          @for (opt of rangeOptions; track opt.days) {
            <button
              type="button"
              class="dropdown__item"
              [class.dropdown__item--active]="selectedRangeDays() === opt.days"
              (click)="selectRange(opt.days)"
            >{{ opt.label }}</button>
          }
        </div>
      }
    </div>
  </app-billing-header>

  @if (usage) {

    <!-- Totals -->
    <div class="api-card">

      <div class="usage-totals-row">
        <div class="usage-section">
          <span class="usage-stat-label">Requests</span>
          <span class="usage-stat-value">{{ usage.totals.requests | number }}</span>
          <svg class="sparkline sparkline--blue" viewBox="0 0 120 32" preserveAspectRatio="none" aria-hidden="true">
            <polyline [attr.points]="sparklinePoints(seriesValues('requests'))" />
            @if (sparklineEndPoint(seriesValues('requests')); as end) {
              <circle class="sparkline__end" [attr.cx]="end.x" [attr.cy]="end.y" r="2.5" />
            }
          </svg>
          <span class="usage-stat-caption">Total API requests</span>
        </div>

        <div class="usage-section">
          <span class="usage-stat-label">Cost</span>
          <span class="usage-stat-value">{{ usage.totals.costCents | money: usage.totals.currency }}</span>
          <svg class="sparkline sparkline--blue" viewBox="0 0 120 32" preserveAspectRatio="none" aria-hidden="true">
            <polyline [attr.points]="sparklinePoints(seriesValues('costCents'))" />
            @if (sparklineEndPoint(seriesValues('costCents')); as end) {
              <circle class="sparkline__end" [attr.cx]="end.x" [attr.cy]="end.y" r="2.5" />
            }
          </svg>
          <span class="usage-stat-caption">Total cost</span>
        </div>

        <div class="usage-section">
          <span class="usage-stat-label">Errors</span>
          <span class="usage-stat-value">{{ usage.totals.errors | number }}</span>
          <span class="usage-stat-range">{{ usage.totals.errorRate * 100 | number:'1.1-1' }}% error rate</span>
          <svg class="sparkline sparkline--muted" viewBox="0 0 120 32" preserveAspectRatio="none" aria-hidden="true">
            <polyline [attr.points]="sparklinePoints(seriesValues('errors'))" />
            @if (sparklineEndPoint(seriesValues('errors')); as end) {
              <circle class="sparkline__end" [attr.cx]="end.x" [attr.cy]="end.y" r="2.5" />
            }
          </svg>
          <span class="usage-stat-caption">Total errors</span>
        </div>

        <div class="usage-section">
          <span class="usage-stat-label">Avg. cost per request</span>
          <span class="usage-stat-value">{{ avgCostCents === null ? '—' : formatAvgCost(avgCostCents, usage.totals.currency) }}</span>
          <span class="usage-stat-caption">Across all endpoints</span>
        </div>
      </div>
    </div>

    <!-- Usage by endpoint -->
    <div class="api-card">
      <div class="api-card__header">
        <div class="api-card__header-stack">
          <span class="api-card__title">Breakdown by endpoint</span>
          <span class="api-card__desc">See which endpoints are used the most.</span>
        </div>
        <div class="dropdown" (appClickOutside)="closeDropdownIfOpen('sort')">
          <button type="button" class="dropdown__trigger" (click)="toggleDropdown('sort', $event)">
            By {{ endpointSort }}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          @if (openDropdown === 'sort') {
            <div class="dropdown__menu">
              <button type="button" class="dropdown__item" [class.dropdown__item--active]="endpointSort === 'requests'" (click)="selectSort('requests')">By requests</button>
              <button type="button" class="dropdown__item" [class.dropdown__item--active]="endpointSort === 'cost'" (click)="selectSort('cost')">By cost</button>
            </div>
          }
        </div>
      </div>

      @if (usage.byEndpoint.length) {
        <div class="usage-col-head" aria-hidden="true">
          <span>Endpoint</span><span>Share of {{ endpointSort }}</span><span>Requests</span><span>Cost</span>
        </div>
        <div class="key-list">
          @for (e of sortedEndpoints(); track e.endpoint) {
            <div class="usage-row">
              <span class="usage-row__endpoint">{{ e.endpoint }}</span>
              <div class="usage-row__bar-wrap">
                <div class="usage-row__bar" [style.width.%]="endpointBarPct(e)"></div>
              </div>
              <span class="usage-row__count">{{ e.requests | number }}</span>
              <span class="usage-row__cost">{{ e.costCents | money: usage.totals.currency }}</span>
            </div>
          }
        </div>
      } @else {
        <div class="empty-state">
          <span class="empty-state__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect x="3" y="10" width="4.5" height="9" rx="1.5" fill="currentColor" opacity="0.55"/>
              <rect x="9.75" y="3" width="4.5" height="16" rx="1.5" fill="currentColor"/>
              <rect x="16.5" y="13" width="4.5" height="6" rx="1.5" fill="currentColor" opacity="0.55"/>
              <path d="M2 21.5H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
          <p class="empty-state__title">No API calls in this range yet.</p>
          <p class="empty-state__desc">Once you start making requests, the breakdown will appear here.</p>
        </div>
      }
    </div>

    <!-- Usage over time -->
    <div class="api-card">
      <div class="api-card__header">
        <div class="api-card__header-stack">
          <span class="api-card__title">{{ chartMetric === 'requests' ? 'Requests' : 'Cost' }} per {{ granularityUnit }}</span>
          <span class="api-card__desc">Grouped by {{ granularityUnit }} for this range.</span>
        </div>
        <div class="seg" role="group" aria-label="Chart metric">
          <button type="button" class="seg__item" [class.seg__item--active]="chartMetric === 'requests'" [attr.aria-pressed]="chartMetric === 'requests'" (click)="setChartMetric('requests')">Requests</button>
          <button type="button" class="seg__item" [class.seg__item--active]="chartMetric === 'costCents'" [attr.aria-pressed]="chartMetric === 'costCents'" (click)="setChartMetric('costCents')">Cost</button>
        </div>
      </div>

      <div class="usage-chart-body">
        <div class="line-chart">
          <div class="line-chart__y-axis">
            @for (tick of chartYTicks(); track tick) {
              <span class="line-chart__y-label" [style.top.%]="gridYPct(tick)">{{ chartMetric === 'requests' ? (tick | number:'1.0-1') : (tick | money: usage.totals.currency) }}</span>
            }
          </div>
          <div class="line-chart__plot" (mouseleave)="onChartLeave()">
            <svg class="line-chart__svg" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              @for (tick of chartYTicks(); track tick) {
                <line class="line-chart__gridline" x1="0" [attr.y1]="gridYPct(tick)" x2="100" [attr.y2]="gridYPct(tick)" />
              }
              <polyline class="line-chart__line" [attr.points]="chartLinePoints()" />
            </svg>
            @for (d of usage.series; track d.date; let i = $index) {
              <button
                type="button"
                class="line-chart__point"
                [class.line-chart__point--hovered]="hoveredIndex === i"
                [style.left.%]="chartPointXPct(i)"
                [style.top.%]="chartPointYPct(d[chartMetric])"
                (mouseenter)="onPointHover(i)"
                (focus)="onPointHover(i)"
                (blur)="onChartLeave()"
                [attr.aria-label]="(d.date | date:'MMM d') + ': ' + (chartMetric === 'requests' ? (d.requests | number) + ' requests' : (d.costCents | money: usage.totals.currency))"
              ></button>
            }
            @if (hoveredPoint; as point) {
              <div class="line-chart__tooltip" [style.left.%]="chartPointXPct(hoveredIndex!)">
                <strong>{{ point.date | date:'MMM d' }}</strong>
                @if (chartMetric === 'requests') {
                  {{ point.requests | number }} requests
                } @else {
                  {{ point.costCents | money: usage.totals.currency }}
                }
              </div>
            }
          </div>
          <div class="chart-date-labels">
            @for (d of thinnedSeries(); track d.date) {
              <span class="chart-date-label">{{ d.date | date:'MMM d' }}</span>
            }
          </div>
        </div>
      </div>
    </div>

  } @else if (loadFailed) {

    <div class="api-card">
      <div class="error-card" role="alert">
        <span class="error-card__icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14Zm.75-9.75a.75.75 0 10-1.5 0v.5a.75.75 0 001.5 0v-.5ZM7.25 8a.75.75 0 011.5 0v3.25a.75.75 0 01-1.5 0V8Z" fill="currentColor"/>
          </svg>
        </span>
        <p class="error-card__title">We couldn't load your usage</p>
        <p class="error-card__desc">Check your connection and try again.</p>
        <button class="btn--primary" type="button" (click)="retry()">Retry</button>
      </div>
    </div>

  } @else {

    <div class="api-card" aria-busy="true" aria-label="Loading usage">
      <div class="usage-totals-row">
        @for (i of [0, 1, 2, 3]; track i) {
          <div class="usage-section">
            <app-skeleton width="90px" height="14px"></app-skeleton>
            <app-skeleton width="120px" height="32px"></app-skeleton>
            <app-skeleton width="100px" height="12px"></app-skeleton>
          </div>
        }
      </div>
    </div>

  }

</div>
